export default new class Drawer {
  constructor () {
    this.initEvents();
    this.elemDrawer = null;
  }

  initEvents () {
    const _this = this;
    document.addEventListener("DOMContentLoaded", () => {
      this.elemDrawer = document.querySelector(".menu-drawer");
      this.elemDrawer.querySelectorAll("[data-action='summary']").forEach(button => button.addEventListener("click", () => this.onClickButton(button)));
      this.elemDrawer.querySelectorAll("[data-action='close']").forEach(button => button.addEventListener("click", () => this.closeDrawer(button)));
      this.elemDrawer.querySelectorAll("[data-action='closeAll']").forEach(button => button.addEventListener("click", () => this.closeAllDrawer()));
      document.addEventListener("keyup", function (event) {_this.onKeyUpEscape(event);});
      document.addEventListener("click", (event) => _this.closeEventBody(event));
    });
  }

  onClickButton (button) {
    button.classList.contains("is-active") ? this.closeDrawer(button) : this.openDrawer(button);
  }

  getContainer (button) {
    return button.closest("[data-action=\"details\"]").querySelector("[data-action=\"container\"]");
  }

  openDrawer (button) {
    button.classList.add("is-active");
    this.getContainer(button).classList.add("is-active");
    button.closest(".menu-drawer").querySelector('.menu-drawer__overlay').classList.add("is-active");
    document.querySelector("html").classList.add("overflow-hidden");
  }

  closeDrawer (button) {
    button.classList.remove("is-active");
    button.closest(".menu-drawer").querySelector('.menu-drawer__overlay').classList.remove("is-active");
    this.getContainer(button).classList.remove("is-active");
    document.querySelector("html").classList.remove("overflow-hidden");
  }

  closeAllDrawer () {
    const summares = document.querySelectorAll(".menu-drawer [data-action='summary'].is-active");
    if (!summares) return;
    summares.forEach(button => {
      this.closeDrawer(button);
    });
  }

  onKeyUpEscape (event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.closeAllDrawer();
  }

  closeEventBody (event) {
    const isClickedOutsideMenu = event.target.closest(".menu-drawer") === null;
    if (isClickedOutsideMenu && document.querySelector(".menu-drawer [data-action=\"summary\"].is-active")) {
      this.closeAllDrawer();
    }
  }
}();

